import { Icon } from '@flintmint/web-shared/components/icon';
import { Loader } from '@flintmint/web-shared/components/loader';
import { Collapse } from '@flintmint/web-shared/components/collapse';

import { useInitialSyncBanner } from '@/hooks/use-initial-sync-banner';

import styles from './initial-sync-banner.module.scss';

export const InitialSyncBanner = () => {
  const { showSyncBanner, syncProgress } = useInitialSyncBanner();

  return (
    <Collapse open={showSyncBanner} unmountOnCollapse className={styles.syncBannerCollapse}>
      <div className={styles.syncBanner} data-testid="initial-sync-banner">
        <div className={styles.content}>
          <Icon type="cloud-download" size={24} data-testid="initial-sync-banner-icon" />
          <div className={styles.copy}>
            <span className={styles.title}>Syncing your data</span>
            <p className={styles.message}>Your files are still loading and will appear as they become available.</p>
          </div>
        </div>
        <Loader type="progress" progress={syncProgress} className={styles.progress} data-testid="initial-sync-progress" />
      </div>
    </Collapse>
  );
};
